<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<h1 class="c-modal__title c-text c-text--xl" *ngIf="vm.isInitialized">{{ 'Symptom_Check.Share_Title' | translate }}</h1>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeShareSymptomCheckButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pb">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div *ngIf="vm.isInitialized">
					<p class="c-text u-osb-md">{{ 'Symptom_Check.Share_Info' | translate }}</p>
					<div *ngIf="!vm.bookings?.length">
						<img alt="No results" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/bg-empty.svg">
						<p id="noUpcomingBookingLabel" class="c-text c-text--center">{{ 'Symptom_Check.Share_No_Bookings' | translate }}</p>
					</div>
					<ul class="u-ost-xl" *ngIf="vm.bookings?.length">
						<li class="o-media c-content u-no-ph" [ngClass]="{'c-content--border-bottom': !$last}" *ngFor="let booking of vm.bookings ; let $index=index ; let $last = last">
							<div class="o-media__img">
								<div class="c-thumb">
									<avatar [user]="booking.service.user" [default]="'doctor'" size="sm"></avatar>
								</div>
							</div>
							<div class="o-media__body">
								<div class="o-grid">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--bold u-osb-xs">{{ booking.scheduledStart | date: 'dd.MM.yyyy HH:mm' }}</p>
										<p class="c-text c-text--gray">{{ booking.service.user.firstname }} {{ booking.service.user.lastname }}<span *ngIf="booking.service.licenseNumber">, {{ booking.service.licenseNumber }}</span></p>
										<div [ngSwitch]="booking.sharingStatus">
											<p class="c-text" id="sharePossibleLabel{{$index}}" *ngSwitchCase="'possible'">{{ 'Symptom_Check.Share_Possible' | translate }}</p>
											<p class="c-text" id="shareExistsLabel{{$index}}" *ngSwitchCase="'exists'">{{ 'Symptom_Check.Share_Exists' | translate }}</p>
											<p class="c-text" id="shareDisabledLabel{{$index}}" *ngSwitchDefault>{{ 'Symptom_Check.Share_Disabled' | translate }}</p>
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed u-no-pr" [ngSwitch]="booking.sharingStatus">
										<button id="shareSymptomCheck{{$index}}" type="button" class="c-button c-button--tp c-button--icon" (click)="vm.share(booking)" *ngSwitchCase="'possible'">
											<i class="o-icon o-icon--share u-no-mr c-text c-text--lg c-text--main" aria-hidden="true"></i>
											<span class="u-sr-only">{{ 'Symptom_Check.Share' | translate }}</span>
										</button>
										<button id="removeSymptomCheck{{$index}}" type="button" class="c-button c-button--tp c-button--icon" (click)="vm.removeShare(booking)" *ngSwitchCase="'exists'">
											<i class="o-icon o-icon--share u-no-mr c-text c-text--lg c-text--s3" aria-hidden="true"></i>
											<span class="u-sr-only">{{ 'Symptom_Check.Share_Remove' | translate }}</span>
										</button>
										<button type="button" class="c-button c-button--tp c-button--icon" disabled="disabled" *ngSwitchCase="'disabled'">
											<i class="o-icon o-icon--share u-no-mr c-text c-text--lg c-text--main" aria-hidden="true"></i>
										</button>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<loader-overlay *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
			</div>
		</div>
	</div>
</div>
